const AdvertiseNewFeature = {
    inserted(el, binding, vnode) {
        var config = parseDirectiveExpression(binding.expression);

        if (!config) {
            console.error("Invalid v-advertise");
            return;
        }

        const daysToAdvertise = 7;
        if (config.goesLiveOn.add(daysToAdvertise, 'days').isBefore()) return;

        var stored = localStorage.getItem("advertised");
        var previouslyAdvertised = stored ? stored.split(",") : [];

        if (previouslyAdvertised.includes(config.id)) return;

        var listener;

        listener = () => { 
            advertise(el); 
            vnode.context.$el.removeEventListener("mouseover", listener);
            previouslyAdvertised.push(config.id);
            localStorage.setItem("advertised", previouslyAdvertised.join(","));
        };

        vnode.context.$el.addEventListener("mouseover", listener);
    }
}


const animationClass = "advertise-animate";

function advertise(el) {
    var innerElement = _.find(el.children, c => c.className.includes("btn"));
    el = innerElement || el;
    if (el.className && el.className.includes(animationClass)) return;
    el.className += " " + animationClass;
    var label = createLabelNew(el);
    setTimeout(() => {
        el.className = el.className.replace(animationClass, "");
        el.parentElement.removeChild(label);
    }, 6000);
}

function createLabelNew(el) {
    var label = document.createElement("div");
    label.append("New");
    var rect = el.getBoundingClientRect();
    label.style.top = rect.bottom + "px";
    label.style.left = rect.left + "px";
    label.className = "advertise-label"
    el.parentElement.append(label);
    return label;
}

function parseDirectiveExpression(expr) {
    expr = expr.replace(/'/gi, "");
    var tokens = expr.split(",").map(t => t.trim());
    if (tokens.length != 2) {
        return;
    }
    var goesLiveOn = moment(Date.parse(tokens[1]));
    if (!goesLiveOn.isValid()) {
        return;
    }

    return { 
        id: tokens[0],
        goesLiveOn: goesLiveOn
    }

}

export default AdvertiseNewFeature;


// WEBPACK FOOTER //
// ./src/framework/utils/advertise-directive.js